import { getAgencyApiHost } from 'api/host-by-env';
import { GetServiceOrderInvoiceRequest, InvoiceDocumentRequest } from 'features/ServiceOrderInvoices/type';
import { handleBusinessError, handleError } from 'utilities/utilities';

export async function getInvoiceDocument(
  invoiceDocumentRequest: InvoiceDocumentRequest,
  token: string,
): Promise<{ result: any; errorCode?: string | number }> {
  const url = `${getAgencyApiHost()}remittance-service/v1/service-order/invoice-document?orderNumber=${
    invoiceDocumentRequest.orderNumber
  }&regionId=${invoiceDocumentRequest.regionId}&invoiceNumber=${invoiceDocumentRequest.invoiceNumber}`;
  const response = await fetch(url, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleBusinessError(json);
  return json.Result;
}

export async function getInvoices(
  token: string,
  request: GetServiceOrderInvoiceRequest,
): Promise<{ result: any; errorCode?: string | number }> {
  let url = `${getAgencyApiHost()}remittance-service/v1/service-order/invoices?firmId=${request.firmId}`;
  if (request.isViewInvoice) {
    url = url + `&isViewInvoice=${request.isViewInvoice}&fromDate=${request.fromDate}&toDate=${request.toDate}`;
  }
  const response = await fetch(url, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });
  const json = await response.json();

  handleError(json);

  // Assuming json.result is an array of invoice objects
  const mappedResult = json.Result?.map((invoice: any) => ({
    isPremium: invoice.IsPremium,
    regionId: invoice.RegionId,
    invoiceNumber: invoice.InvoiceNumber,
    invoicedAmount: invoice.InvoicedAmount,
    invoiceBalance: invoice.InvoiceBalance,
    invoiceDate: invoice.InvoiceDate,
    invoiceStatus: invoice.InvoiceStatus,
    buyer: invoice.Buyer,
    orderNumber: invoice.OrderNumber,
    propertyAddress: invoice.PropertyAddress,
    officeAddress: invoice.OfficeAddress,
    fileNumber: invoice.FileNumber,
    paymentId:
      invoice.PaymentId ??
      invoice.paymentId ??
      invoice.PaymentID ??
      invoice.Payment?.PaymentId ??
      invoice.Payment?.Id ??
      invoice.payment?.paymentId ??
      null,
    paymentCreatedDate: invoice.PaymentCreatedDate ?? invoice.paymentCreatedDate,
    PaymentCreatedDate: invoice.PaymentCreatedDate ?? invoice.paymentCreatedDate,
  }));

  return mappedResult;
}

export async function exportReports(files: any, token: string, tabName: string): Promise<any> {
  const url = `${getAgencyApiHost()}remittance-service/v1/service-order/invoices-export`;
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(files),
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleError(json);
  return json.Result;
}

export async function getServiceOrderTransmittalSheet(
  token: string,
  paymentId: number,
  invoiceNumber: string,
): Promise<{ transmittalSheet: string }> {
  const url = `${getAgencyApiHost()}remittance-service/v1/service-order/transmittal-sheet?paymentId=${paymentId}&invoiceNumber=${encodeURIComponent(
    invoiceNumber,
  )}`;
  const response = await fetch(url, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  handleError(json);
  return { transmittalSheet: json.Result };
}
